const ko = {
    inv: '재고',
    trade: '무역',
    transfer: '전송',
    temporary: '임시',
    inbound: '인바운드',
    outbound: '아웃바운드',
    scanOrder: '스캔 순서',
    inputOrder: '입력 순서',
    beConfirmed: '확인될 것',
    confirmed: '확인됨',
    invInProgress: '재고 진행 중',
    genertDifferences: '차이점 생성',
    cpletDifIn: '차이점 저장 완료',
    cpletDifOut: '창고에서 완전한 차이',
    cplet: '완료',
    inboundSuccess: '인바운드 성공',
    outboundSuccess: '아웃바운드 성공',
    conIn: '저장 확인',
    conOut: '배달 확인',
    perOutbound: '출고 전',
    normalType: "일반 자재",
    completeType: "완제품",
    wastedType: "폐기 자재",
    tempType: "임시(중계) 로케이션",
    locationType: "로케이션 유형",
    outter: "외부 위치/해외 위치",
    productionType: "생산 로케이션",
    defectiveReturnType: "불량품 반품 로케이션",
    defectiveTempType: "불량품 임시 로케이션",
    locLocked: "로케이션 잠김/실사 중",
    preOutExsist: "로케이션에 사전 출고 존재",
    locNull: "로케이션 없음",
    proQtyFalse: "제품 수량 불일치",
    calcErr: "주문 위치 계산 오류",
    list: "기록",
    batchAdd: "입고",
    adjust: "출고",
    count: "실사",
    batchNo: "배치 번호",
    opType: "작업 유형",
    beforeCount: "변경 전 수량",
    changeCount: "변경 수량",
    afterCount: "변경 후 수량",
    createdAt: "생성 시간",
    inventoryType: "입출고 유형",
};

export default ko;